import MenuLateral from "../MenuLateral/menulateral";
import MenuLateralMobile from "../MenuLateral/menulateralmobile";
import EmplacarTabela from "./tabela";

function Listagem() {  
  
    return (
        <div class="container-fluid">
            <div class="row">
                <MenuLateral menu="emplacar" admin={false}/>
                <MenuLateralMobile />
                <div class="col-12 col-lg-2 mobile-hide invisible"></div>            
                <div id="conteudo" class="col-12 col-lg-10">
                    <EmplacarTabela />
                </div>           
            </div>
        </div>  
    );
  
  }
  
  export default Listagem;